function initializeGreetingCardSections(container = document) {
  const sections = container.querySelectorAll(
    '[data-greeting-cards-section]'
  );

  sections.forEach((section) => {
    if (section.dataset.greetingCardsInitialized === 'true') {
      return;
    }

    section.dataset.greetingCardsInitialized = 'true';

    const cards = section.querySelectorAll('.greeting-card');
    const messageField = section.querySelector(
      '.greeting-message__textarea'
    );
    const characterCount = section.querySelector(
      '.greeting-message__count'
    );
    const submitButton = section.querySelector(
      '[data-greeting-card-submit]'
    );
    const statusMessage = section.querySelector(
      '[data-greeting-card-status]'
    );

    let selectedCard = '';

    function updateButtonState() {
      if (!submitButton) {
        return;
      }

      submitButton.disabled = selectedCard === '';
    }

    function showStatus(message, type = '') {
      if (!statusMessage) {
        return;
      }

      statusMessage.textContent = message;
      statusMessage.classList.remove(
        'is-success',
        'is-error'
      );

      if (type) {
        statusMessage.classList.add(`is-${type}`);
      }
    }

    function selectCard(card) {
      cards.forEach((currentCard) => {
        const isSelected = currentCard === card;

        currentCard.classList.toggle(
          'is-selected',
          isSelected
        );

        currentCard.setAttribute(
          'aria-checked',
          isSelected ? 'true' : 'false'
        );
      });

      selectedCard = card.dataset.cardTitle || 'Grußkarte';

      section.dataset.selectedGreetingCard = selectedCard;

      showStatus('');
      updateButtonState();
    }

    cards.forEach((card) => {
      card.addEventListener('click', () => {
        selectCard(card);
      });

      card.addEventListener('keydown', (event) => {
        if (event.key === 'Enter' || event.key === ' ') {
          event.preventDefault();
          selectCard(card);
        }
      });
    });

    if (messageField && characterCount) {
      function updateCharacterCount() {
        characterCount.textContent =
          `${messageField.value.length} / 300`;
      }

      messageField.addEventListener(
        'input',
        updateCharacterCount
      );

      updateCharacterCount();
    }

    if (submitButton) {
      submitButton.addEventListener('click', async () => {
        const variantId = Number(section.dataset.variantId);
        const personalMessage =
          messageField?.value.trim() || '';

        if (!selectedCard) {
          showStatus(
            'Bitte wähle zuerst eine Grußkarte aus.',
            'error'
          );
          return;
        }

        if (!variantId) {
          showStatus(
            'Bitte wähle im Theme-Editor das Produkt „Kostenlose Grußkarte“ aus.',
            'error'
          );
          return;
        }

        submitButton.disabled = true;
        submitButton.classList.add('is-loading');
        submitButton.textContent = 'Wird hinzugefügt …';

        showStatus('');

        try {
          const rootUrl =
            window.Shopify?.routes?.root || '/';

          const response = await fetch(
            `${rootUrl}cart/add.js`,
            {
              method: 'POST',
              headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json'
              },
              body: JSON.stringify({
                items: [
                  {
                    id: variantId,
                    quantity: 1,
                    properties: {
                      Grußkarte: selectedCard,
                      'Persönliche Nachricht':
                        personalMessage ||
                        'Keine persönliche Nachricht'
                    }
                  }
                ]
              })
            }
          );

          const result = await response.json();

          if (!response.ok) {
            throw new Error(
              result.description ||
              result.message ||
              'Die Grußkarte konnte nicht hinzugefügt werden.'
            );
          }

          showStatus(
            '✓ Deine Grußkarte wurde kostenlos zur Bestellung hinzugefügt.',
            'success'
          );

          submitButton.textContent = 'Grußkarte hinzugefügt ✓';

          document.dispatchEvent(
            new CustomEvent('cart:refresh', {
              bubbles: true
            })
          );

          document.dispatchEvent(
            new CustomEvent('cart:updated', {
              bubbles: true,
              detail: {
                cart: result
              }
            })
          );

          setTimeout(() => {
            submitButton.textContent =
              'Kostenlos zur Bestellung hinzufügen';

            submitButton.classList.remove('is-loading');
            updateButtonState();
          }, 2500);
        } catch (error) {
          console.error(
            'Fehler beim Hinzufügen der Grußkarte:',
            error
          );

          showStatus(
            error.message ||
            'Die Grußkarte konnte leider nicht hinzugefügt werden.',
            'error'
          );

          submitButton.textContent =
            'Kostenlos zur Bestellung hinzufügen';

          submitButton.classList.remove('is-loading');
          updateButtonState();
        }
      });
    }

    updateButtonState();
  });
}

document.addEventListener('DOMContentLoaded', () => {
  initializeGreetingCardSections();
});

document.addEventListener('shopify:section:load', (event) => {
  initializeGreetingCardSections(event.target);
});